export function addDaysToDatetime(datetime: string, amountDays = 7): string {
    const newDate = new Date(datetime);
    newDate.setDate(newDate.getDate() + amountDays);
    const stringNewDate = newDate.toISOString();
    return stringNewDate;
}

export function formatDatetime(datetime: string): string {
    const datePart = datetime.split("T")[0];
    const [year, month, day] = datePart.split("-");
    const formattedDate = `${day}/${month}/${year}`;
    return formattedDate;
}
